import {t, useLanguage, interfaceLocale} from '../../i18n';
import React, { useState } from "react";
import "./BusinessMembershipRenewal.css";
import { callCallableNativeSafe } from "../../utils/callableNativeSafe";

export default function BusinessMembershipRenewal({ businessId, membershipId, onCompleted }) {
  useLanguage();
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const call = async (operation) => {
    setBusy(true); setError("");
    try {
      const result = await callCallableNativeSafe({ functionName: "businessMembershipRenewal", data: { businessId, membershipId, operation }, requireAuth: true, requireAppCheck: true });
      setPreview(result.data);
      if (operation === "disable") onCompleted?.();
    } catch (err) { setError(err.message || "No pudimos consultar la renovación. Intenta nuevamente."); }
    finally { setBusy(false); }
  };
  const date = preview?.currentPeriodEnd ? new Date(preview.currentPeriodEnd).toLocaleDateString(interfaceLocale(), { day: "numeric", month: "short", year: "numeric" }) : null;
  return <div className="business-membership-renewal">
    {!preview ? <button type="button" disabled={busy} onClick={() => call("preview")}>{busy ? t("Consultando…") : t("Gestionar renovación")}</button> : <>
      <p>{preview.cancelAtPeriodEnd ? t("No renueva.") : t("Renovación automática.")} {date && t("Vigente hasta {date}.", {date})}</p>
      {preview.canDisable && <>
        <p>{t("Al desactivarla, conserva los beneficios del período pagado. Un cobro que ya esté en proceso puede completarse.")}</p>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button type="button" disabled={busy} onClick={() => call("disable")}>{busy ? t("Guardando…") : t("Desactivar renovación")}</button>
          <button type="button" disabled={busy} onClick={() => setPreview(null)}>{t("Volver")}</button>
        </div>
      </>}
      {!preview.canDisable && !preview.cancelAtPeriodEnd && <p>{t("No se puede cambiar la renovación en este estado.")}</p>}
    </>}
    {error && <p role="alert">{t(error)}</p>}
  </div>;
}
